import { useComputed } from "@homebound/beam";
import { useRouteParams } from "src/hooks/useRouteParams";
import { BaseChangeEventFormState } from "src/routes/projects/change-events/guided/baseChangeEventForm";
import { ReviewStep } from "src/routes/projects/change-events/guided/workflows/sharedSteps/ReviewStep";
import { WorkflowFormState } from "src/routes/projects/change-events/guided/workflows/types";
import { GuidedChangeEventParams } from "src/routes/routesDef";
import { ApplyConfigurationFormInput } from "../applyConfigurationForm";
import { scheduleImpactVariablesFor } from "../reviewImpactUtils";
import { ScheduleImpactSummaryValue } from "./ScheduleImpactSummaryValue";

type ApplyConfigurationReviewStepProps = { formState: WorkflowFormState<ApplyConfigurationFormInput> };

/**
 * The wizard's final step, i.e. the shared review of the change event step 1 saved.
 *
 * With a signed contract that is a real draft and Create sends it for approval. Without one step 1 only dry ran the
 * save, so the review summarizes the same derivation, but Apply then writes the configuration straight onto the
 * project and no change event is created, which is what the step says instead of routing anything for approval.
 */
export function ApplyConfigurationReviewStep(props: ApplyConfigurationReviewStepProps) {
  const { formState } = props;
  const { projectId } = useRouteParams<GuidedChangeEventParams>();
  const savedChangeEventId = useComputed(() => formState.id.value, [formState]);
  const targetConfigId = useComputed(() => formState.targetConfigId.value, [formState]);
  return (
    <ReviewStep
      formState={formState as BaseChangeEventFormState<ApplyConfigurationFormInput>}
      willCreateChangeEvent={!!savedChangeEventId}
      scheduleImpact={
        <ScheduleImpactSummaryValue
          variables={scheduleImpactVariablesFor(projectId, savedChangeEventId, targetConfigId)}
        />
      }
    />
  );
}
